import styled from "@emotion/styled"
import colors from "theme/colors"
import { ImageContainer, NewText, TitleWithLine } from "ui"
import { extractProperty } from "utils"
import { getNonUmbracoURL } from "utils/utils"

const StyledWrapper = styled.div`
`
const StyledTitleAndText = styled.div`
    padding-top: 10px;
    padding-bottom: 20px;
${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
    &:first-child {
        padding-top: 0;
    }
    a {
        text-decoration: none;
             color: ${colors.blue};
        }
    a :hover {
        text-decoration: underline;
    }

    h2{
     /* color: ${colors.blue}; */
     line-height: 24px;
    }
`

function ArticleContentBlockCharge({ data }: { data: any }) {

    const title = extractProperty(data, "title")
    const content = extractProperty(data, "content")
    const image = extractProperty(data, "image")

    return (
        <StyledWrapper>
            {image &&
                <ImageContainer
                    desktopUrl={getNonUmbracoURL(image)}
                    sm={true}
                    objectPosition="right top"
                    height={500}
                    mobileHeight={420}
                    emptyAlt
                />
            }
            <StyledTitleAndText>
                {title &&
                    <TitleWithLine
                        title={title}
                        component={"h2"}
                        titleColor="black"
                        titleFontSize={34}
                        desktopLineHeight="36px"
                        mobileTitleFontSize={24}
                        mobileLineHeight="28px"
                    />}
                {content &&
                    <NewText
                        component={"p"}
                        largeDesktopFontSize={18}
                        largeDesktopLineHeight="20px"
                        desktopFontSize={18}
                        desktopLineHeight={"20px"}
                        desktopFontWeight={400}
                        mobileFontSize={16}
                        mobileLineHeight={"18px"}
                        mobileFontWeight={400}
                        style={{ paddingTop: 10 }}
                        dangerouslySetInnerHTML={{ __html: content }}
                    />
                }
            </StyledTitleAndText>
        </StyledWrapper>
    )
}
export default ArticleContentBlockCharge
